import { DefaultLocale } from '@constants';
import { getLocaleLabels, enIN } from '@constants/locales';
import { useLocale, useStore } from '@app/store';

const interpolateString = (str, result) => str.replace(/{(.+?)}/g, (_, g1) => result[g1] || g1);

const getActiveLocale = () => {
  try {
    return useStore.getState().locale || DefaultLocale;
  } catch {
    return DefaultLocale;
  }
};

const resolveLabel = (key) => {
  const locale = getActiveLocale();
  const labels = getLocaleLabels(locale);
  if (labels && labels[key] !== undefined) return labels[key];
  if (enIN[key] !== undefined) return enIN[key];
  return key;
};

export const getTranslation = (key, data) => {
  const str = resolveLabel(key);
  if (str == null) return '';

  let parts = String(str).split('$').filter((i) => i);
  if (parts.length === 0) parts = [String(str)];

  if (data) {
    parts.forEach((subStr, index) => {
      parts[index] = interpolateString(subStr, data);
    });
  }
  return `${parts}`;
};

// Use this in components so the translated output re-renders on locale switch.
// `getTranslation` reads the locale via `useStore.getState()` without
// subscribing, so components that call it directly won't re-render on their
// own — this hook ties the subscription and the translate call together.
export const useTranslation = () => {
  useLocale();
  return getTranslation;
};
